import { memo, useMemo } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeHighlight from "rehype-highlight";
import { CopyButton } from "@/components/chat/CopyButton";

function nodeText(node) {
  if (!node) return "";
  if (node.type === "text") return node.value;
  return (node.children || []).map(nodeText).join("");
}

function CodeBlock({ node, children, ...props }) {
  const code = node?.children?.[0];
  const className = (code?.properties?.className || []).join(" ");
  const language = /language-([\w+-]+)/.exec(className)?.[1] || "code";
  return (
    <div className="cs-code" data-testid="markdown-code-block">
      <div className="cs-code-head">
        <span>{language}</span>
        <CopyButton text={nodeText(code).replace(/\n$/, "")} label="Copy code" testId="copy-code-button" />
      </div>
      <pre {...props}>{children}</pre>
    </div>
  );
}

const components = {
  pre: CodeBlock,
  a: ({ node, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer nofollow" />,
  table: ({ node, ...props }) => (
    <div className="cs-table-wrap">
      <table {...props} />
    </div>
  ),
};

const rehypePlugins = [[rehypeHighlight, { detect: false, ignoreMissing: true }]];
const remarkPlugins = [remarkGfm];

export const Markdown = memo(function Markdown({ content, components: extra }) {
  const merged = useMemo(() => (extra ? { ...components, ...extra } : components), [extra]);
  return (
    <ReactMarkdown remarkPlugins={remarkPlugins} rehypePlugins={rehypePlugins} components={merged}>
      {content}
    </ReactMarkdown>
  );
});
